import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { IEntityLicense } from 'app/models/licenses/entity-license';
import { Observable } from 'rxjs';
import { ISearch } from 'app/models/licenses/search';
import { IStaff } from 'app/models/user/staff';

@Injectable({providedIn: 'root'})
export class EntityLicenseService {
  public api: string = environment.privateApi + 'EntityLicense/';
  private http = inject(HttpClient);

  getStaff(): Observable<IStaff[]>{
    return this.http.get<IStaff[]>(this.api + 'GetStaff');
  }

  searchLicenses(search: ISearch): Observable<IEntityLicense[]>{
    return this.http.post<IEntityLicense[]>(this.api + 'searchLicenses', search);
  }

  assignLicense(licenseId: number, staff: IStaff): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'AssignLicense/' + licenseId, staff);
  }

  approveLicense(licenseId: number, approved: boolean): Observable<IEntityLicense>{
    return this.http.post<IEntityLicense>(this.api + 'ApproveLicense/' + licenseId + '/' + approved, null);
  }

  createLicense(): Observable<IEntityLicense>{
    return this.http.post<IEntityLicense>(this.api + 'CreateLicense', null);
  }

  updateLicense(license: IEntityLicense): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'UpdateLicense', license);
  }

  getLicenses(): Observable<IEntityLicense[]>{
    return this.http.get<IEntityLicense[]>(this.api + 'GetLicenses');
  }

  submitLicense(license: IEntityLicense): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'SubmitLicense', license);
  }
}
